import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { I18nService, LgType } from '../../../../services/prod/i18n.service'
import { IColorGroup, IColors, IStyleItems, SetColorsService } from '../../../../services/set-colors.service'
import { AppType } from '../../../../types/app.type'
import { ThemeTitleType } from '../../../../types/color-settings.type'

@Component({
  selector: 'bmcore-color-block',
  templateUrl: './bmcore-color-block.component.html',
  styleUrls: ['./bmcore-color-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreColorBlockComponent implements OnInit {
  @Input() group: IColorGroup
  @Input() groups: IColorGroup[]
  @Input() currentGroupTitle: string
  @Output() changeThemeEvent = new EventEmitter<ThemeTitleType>()
  @Input() appType: AppType

  lg: LgType
  Object = Object // for Object keys
  currentStyleItemTitle: string

  constructor(
    private setColorsService: SetColorsService,
    private i18nService: I18nService
  ) {}

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()
  }

  changeColorSettings(event: MouseEvent, key: string) {
    event.stopPropagation()
    if (key === this.currentStyleItemTitle) {
      // If clicked on the same group then close this group
      this.currentStyleItemTitle = ''
    } else {
      this.currentStyleItemTitle = key
    }
  }

  getStyleItemColors(key: string): IColors {
    return this.getStyleItem(key).colors
  }

  // styleItem - object (color settings) for concrete blue button
  getStyleItem(key: string): IStyleItems {
    return this.getCurrentGroupByTitle().styleItems[key]
  }

  getCurrentGroupByTitle(): IColorGroup {
    return this.groups.find(item => {
      return item.title === this.currentGroupTitle
    })
  }

  getCurrentStyleItemColors(): IColors {
    return this.getStyleItemColors(this.currentStyleItemTitle)
  }

  refreshStylesOnPage(): void {
    this.setColorsService.refreshStyleTag('custom')
    this.changeThemeEvent.emit('custom')
  }
}
